<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      label-width="120px"
      label-position="top"
      size="mini"
      :rules="rules"
      :disabled="disabled"
    >
      <div class="d-flex">
        <div class="pr-1 image_div">
          <el-image
            :src="defaultImageUrl"
            :preview-src-list="[defaultImageUrl]"
            style="width:135px; height:135px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width:135px; height:135px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1">
          <div class="el-descriptions">
            <div class="el-descriptions__body descriptions__body_header">
              <div
                class="el-descriptions__table is-bordered el-descriptions--small"
              >
                <div class="el-descriptions-row">
                  <div
                    class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label bg-white"
                    style="padding:6px"
                  >
                    <div class="sku_main">
                      <div>
                        <span v-if="formData.goodsName">
                          {{ formData.goodsName }}
                        </span>
                      </div>
                      <div>
                        <span v-if="formData.goodsNameEn">
                          {{ formData.goodsNameEn }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-descriptions border size="small" class="bottom-desc" :column="2">
            <el-descriptions-item
              :label="$l('form_label_SkuNo') || 'SKU款号'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.amzSkuNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_amzPurchaseNo') || '采购单号'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.amzPurchaseNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_ncNo') || 'NC编号'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.ncNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_brandName') || '品牌'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.brandName }}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions border size="small" class="bottom-desc" :column="2">
            <el-descriptions-item
              :label="$l('form_label_goodsSize') || '尺寸'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.goodsSize }}
            </el-descriptions-item>

            <el-descriptions-item
              :label="$l('form_label_inCtnQty') || '入数'"
              :labelStyle="{ width: '120px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.inCtnQty }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <el-row :gutter="10" type="flex" justify="space-between" class="mt-2">
        <el-col>
          <el-form-item
            :label="$l('form_label_purchaseQty') || '采购数量'"
            prop="purchaseQty"
          >
            <el-input v-model="formData.purchaseQty" readonly />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="$l('form_label_shortageQuantity') || '短装数量'">
            <el-input v-model="formData.shortageQuantity" readonly />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item :label="$l('form_label_invQty') || '可出货数量'">
            <el-input v-model="formData.invQty" readonly />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$l('form_label_shippedQty') || '已出货数量'"
            prop="shippedQty"
          >
            <el-input-number
              v-model="formData.shippedQty"
              style="width: 100%"
              controls-position="right"
              :min="0"
              :step="1"
              :controls="false"
              :precision="0"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    amzPurchaseDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        shippedQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (value > this.maxShippedQty) {
                callback(
                  new Error(
                    this.$l(
                      'tips_shippedQty_exceeds_available'
                    ) || '已出货数量 不能大于 采购数量-短装数量'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
    maxShippedQty() {
      const purchaseQty = Number(this.formData.purchaseQty || 0)
      const shortageQuantity = Number(this.formData.shortageQuantity || 0)
      return purchaseQty - shortageQuantity
    },
  },
  methods: {
    init() {
      if (!this.amzPurchaseDetailCode) return
      this.$api
        .ecomAmzFtyPurchaseDetailDetailApi({
          amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    async save() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const params = { ...this.formData }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailUpdateShippedApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.image_div {
  border: 1px solid #ebeef5;
  border-right: none;
}

.sku_main {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  // height: 49px;
  // line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side_frame_div {
  height: 25px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
